<template v-if="hasInstructions">
  <section class="recipe__instructions">
    <section v-for="(section, index) in sectionedItems" :key="`section-${index}`">
      <h5 :class="{
        'mui-list-section': true,
        'mui-position--first': index === 0
      }" v-if="section.title">{{section.title.replace(/\:$/, '')}}</h5>
      <ol
        class="mui-list mui-list--static"
        :style="{
          'counterReset': `list ${sectionStart(index)}`
        }"
        :start="sectionStart(index)">
        <li
          class="mui-list-item ff-frac"
          :data-item-key="item.key"
          :id="`instruction-${item.key}`"
          v-for="(item, index) in section.items"
          :key="index">
          <span class="static">{{item.text}}</span>
        </li>
      </ol>
    </section>
  </section>
</template>

<script>
import { splitObjectByProperty } from '@/utils'
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sectionedItems () {
      return splitObjectByProperty(this.items, 'section')
    }
  },
  methods: {
    sectionStart (index) {
      return this.sectionedItems.slice(0, index).reduce((total, el) => {
        return total + el.items.length
      }, 0)
    }
  }
}
</script>

<style lang="sass">
.recipe__instructions
  h5.mui-list-section
    margin-bottom: 7px
    text-transform: uppercase
    font-weight: 600
    font-size: 16px
    line-height: 26px
    &.mui-position--first
      margin-top: 0
.recipe__instructions
  ol.mui-list
    counter-reset: list
    list-style: none
    margin-left: 0
    padding-left: 0
    margin-top: 0
  .mui-list-item
    display: list-item
    counter-increment: list
    margin-left: 24px
    padding-left: 0
    position: relative
    overflow: visible
    font-size: 16px
    line-height: 26px
    &:before
      content: counter(list)
      font-feature-settings: 'salt' 1
      font-weight: 400
      left: -24px
      margin-right: 12px
      position: absolute
</style>



// WEBPACK FOOTER //
// src/components/Recipe/Instructions.vue